// extracted by mini-css-extract-plugin
export default {"bottomRight":"DataStructuresPage_bottomRight__A+5JW"};